import React, { useEffect, useState } from "react";
import { Col, Row, Form, Input, Checkbox } from "antd";
import { ButtonProps, getWalletDays } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import "./../../styles/modal.css";
import { FiPlusCircle } from "react-icons/fi";
import MeshBillModal from "../Items/Modal/Index";
import MeshBillButton from "../Items/Button/Index";
// const MeshBillSelect = lazy(() => import("../Items/Select/Index"));
// const MeshBillModal = lazy(() => import("../Items/Modal/Index"));
// const MeshBillButton = lazy(() => import("../Items/Button/Index"));

const UpdateStaffPasswordModalComponent: React.FC<
  UpdateStaffProfileModalProp
> = ({ show, handleClose, activeStaff }) => {
  const { openNotification, contextHolder } = useMultiNotification();
  const [form] = Form.useForm();
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<UpdateStaffPasswordApiProp>(
    "auth/updateMyStaffPassword",
    true
  );

  const onFinish = (values: any) => {
    const { password } = values;

    const dataToSend: UpdateStaffPasswordApiProp = {
      password,
      intPkHeadID: activeStaff.intPkHeadID,
    };
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  const validateConfirmPassword = (_: any, value: string) => {
    const { password } = form.getFieldsValue();
    console.log({ password });
    if (value && value !== password) {
      return Promise.reject(
        new Error("The two passwords that you entered do not match!")
      );
    }
    return Promise.resolve();
  };
  return (
    <>
      <MeshBillModal
        title="Update Staff Password"
        headerStyle={{
          backgroundColor: "var(--primary-background-color)",
          color: "var(--primary-text-color)",
          fontSize: "16px",
          fontWeight: "var(--fw-700)",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          if (apiLoading) {
            return;
          }
          handleClose(false);
        }}
      >
        {contextHolder}

        <Row>
          <Col
            span={24}
            className="meshbill-create-record-modal-form-container"
          >
            <Form
              //   requiredMark={true}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="updateStaffPasswordForm"
              form={form}
            >
              <Form.Item
                label={
                  <span className="create-user-form-label">New Password</span>
                }
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please Enter New Password",
                  },
                  {
                    min: 6,
                    message: "There Should be minium of 6 characters",
                  },
                ]}
              >
                <Input.Password
                  className="user-input-general-height"
                  placeholder="Enter New Password"
                />
              </Form.Item>
              <Form.Item
                dependencies={["password"]}
                label={
                  <span className="create-user-form-label">
                    Confirm Password
                  </span>
                }
                name="confirmPassword"
                rules={[
                  {
                    required: true,
                    message: "Please Confirm Password",
                  },
                  // {
                  //   min: 6,
                  //   message: "There Should be minium of 6 characters",
                  // },
                  {
                    validator: validateConfirmPassword,
                  },
                ]}
              >
                <Input.Password
                  className="user-input-general-height"
                  placeholder="Enter New Password"
                />
              </Form.Item>
              <Form.Item>
                <MeshBillButton
                  backgroundColor={ButtonProps.background.STANDARD}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Update Staff"
                  disabled={apiLoading}
                  // icon={<FiPlusCircle />}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </MeshBillModal>
    </>
  );
};
export default UpdateStaffPasswordModalComponent;
